<template>
  <div>
    <span
      :class="['bmd-form-group mb-2 d-block form-label-group']"
      @click="init_popup"
    >
      <input
        type="text"
        readonly
        class="form-control"
        :value="result"
        :placeholder="label"
        autocomplete="off"
        style="cursor: auto"
        :id="id"
      />
      <label :for="id" class="form-label-group-label shorter">{{
        label
      }}</label>
      <span
        class="btn btn-default"
        style="position: absolute; right: 0; top: 8px"
        ><i class="fa fa-edit"></i
      ></span>
    </span>
    <b-modal
      :id="'modal-address' + id"
      :hide-footer="true"
      size="lg"
      :title="$t('message.contracts.add_address')"
      button-size="lg"
    >
      <div class="row">
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="postcode"
              :placeholder="$t('message.contracts.address_postcode')"
              autocomplete="off"
              style="cursor: auto"
              :id="'postcode' + id"
            />
            <label
              :for="'postcode' + id"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.address_postcode") }}</label
            >
          </span>
        </div>
        <div class="col-md-6">
          <span
            :class="[
              'bmd-form-group mb-1 d-block  form-label-group',
              country_focused ? 'focused' : '',
            ]"
          >
            <v-select
              :id="'country' + id"
              :options="countries"
              label="display_text"
              :class="[
                'form-control',
                typeof country !== 'undefined' && country.value !== ''
                  ? 'vs--selected'
                  : '',
              ]"
              @search="fetchCountries"
              @focus="country_focused = true"
              @blur="country_focused = false"
              v-model="country"
              :placeholder="$t('message.contracts.address_country')"
            ></v-select>
            <label
              :for="'country' + id"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.address_country") }}</label
            >
          </span>
        </div>
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="region"
              :placeholder="$t('message.contracts.address_region')"
              autocomplete="off"
              style="cursor: auto"
              :id="'region' + id"
            />
            <label
              :for="'region' + id"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.address_region") }}</label
            >
          </span>
        </div>
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="city"
              :placeholder="$t('message.contracts.address_city')"
              autocomplete="off"
              style="cursor: auto"
              :id="'city' + id"
            />
            <label :for="'city' + id" class="form-label-group-label shorter">{{
              $t("message.contracts.address_city")
            }}</label>
          </span>
        </div>
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="town"
              :placeholder="$t('message.contracts.address_town')"
              autocomplete="off"
              style="cursor: auto"
              :id="'town' + id"
            />
            <label :for="'town' + id" class="form-label-group-label shorter">{{
              $t("message.contracts.address_town")
            }}</label>
          </span>
        </div>
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="street"
              :placeholder="$t('message.contracts.address_street')"
              autocomplete="off"
              style="cursor: auto"
              :id="'street' + id"
            />
            <label
              :for="'street' + id"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.address_street") }}</label
            >
          </span>
        </div>
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="number"
              :placeholder="$t('message.contracts.address_number')"
              autocomplete="off"
              style="cursor: auto"
              :id="'number' + id"
            />
            <label
              :for="'number' + id"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.address_number") }}</label
            >
          </span>
        </div>
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="office"
              :placeholder="$t('message.contracts.address_office')"
              autocomplete="off"
              style="cursor: auto"
              :id="'office' + id"
            />
            <label
              :for="'office' + id"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.address_office") }}</label
            >
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-2 d-block']">
            <select
              class="form-control"
              v-model="code_of_type"
              :placeholder="$t('message.contracts.address_code_of_type')"
              autocomplete="off"
              style="cursor: auto; height: 56px"
              :id="'cot' + id"
            >
              <option value="">
                {{ $t("message.contracts.address_type_none") }}
              </option>
              <option value="em">
                {{ $t("message.contracts.address_type_em") }}
              </option>
              <option value="fx">
                {{ $t("message.contracts.address_type_fx") }}
              </option>
              <option value="te">
                {{ $t("message.contracts.address_type_te") }}
              </option>
              <option value="tg">
                {{ $t("message.contracts.address_type_tg") }}
              </option>
              <option value="tl">
                {{ $t("message.contracts.address_type_tl") }}
              </option>
            </select>
          </span>
        </div>
        <div class="col-md-6">
          <span
            :class="['bmd-form-group mb-2 d-block form-label-group']"
            v-if="code_of_type !== ''"
          >
            <input
              type="text"
              class="form-control"
              v-model="additional_data"
              :placeholder="
                $t('message.contracts.address_typed_field_' + code_of_type)
              "
              autocomplete="off"
              style="cursor: auto"
              :id="'typed_field' + id"
            />
            <label
              :for="'typed_field' + id"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.address_typed_field_" + code_of_type)
              }}</label
            >
          </span>
        </div>
      </div>

      <button @click="save" class="btn btn-success">
        {{ $t("message.save") }}
      </button>
    </b-modal>
  </div>
</template>
<script>
export default {
  props: ["value", "label"],
  data() {
    return {
      postcode: "",
      country: { value: "" },
      region: "",
      city: "",
      town: "",
      street: "",
      number: "",
      office: "",
      code_of_type: "",
      additional_data: "",
      country_focused: false,
      countries: [],
    };
  },
  methods: {
    save() {
      this.$emit("input", this.result);
      this.$bvModal.hide("modal-address" + this.id);
    },
    init_popup() {
      this.$bvModal.show("modal-address" + this.id);
    },
    fetchCountries(search, loading) {
      this.getLibrary("country", search, 10000);
    },
    getLibrary(type, query, qty) {
      query = query.toLowerCase();
      axios
        .get(
          window.base +
            "/library?type=" +
            type +
            "&query=" +
            query +
            "&qty=" +
            qty +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          var var_name = type;
          if (type[type.length - 1] == "s") {
            var_name = type + "es";
          } else if (type[type.length - 1] == "y") {
            var_name = type.substring(0, type.length - 1) + "ies";
          } else {
            var_name = type + "s";
          }
          this.$data[var_name] = [];
          response.data.forEach((item) => {
            if (item.value !== "··········") this.$data[var_name].push(item);
          });
        });
    },
  },
  mounted() {
    this.fetchCountries("");
    if (this.value.trim() !== "") {
      setTimeout(() => {
        let parts = this.value.split(",");
        this.postcode = parts[0].trim();
        this.country =
          this.countries[
            this.countries.findIndex(
              (i) => i.display_text.trim() == parts[1].trim(),
            )
          ];
        this.region = parts[2].trim();
        this.city = parts[3].trim();
        this.town = parts[4].trim();
        this.street = parts[5].trim();
        this.number = parts[6].trim();
        this.office = parts[7].trim();

        this.additional_data = parts[8].trim().split(":");
        if (this.additional_data.length > 1) {
          this.code_of_type = "";
          switch (this.additional_data[0].trim().toLowerCase()) {
            case this.$t("message.contracts.address_type_em").toLowerCase():
              this.code_of_type = "em";
              break;
            case this.$t("message.contracts.address_type_fx").toLowerCase():
              this.code_of_type = "fx";
              break;
            case this.$t("message.contracts.address_type_te").toLowerCase():
              this.code_of_type = "te";
              break;
            case this.$t("message.contracts.address_type_tg").toLowerCase():
              this.code_of_type = "tg";
              break;
            case this.$t("message.contracts.address_type_tl").toLowerCase():
              this.code_of_type = "tl";
              break;
          }
          this.additional_data = this.additional_data[1].trim();
        }
      }, 1000);
    }
  },
  computed: {
    locale() {
      var locale = this.$i18n.locale;
      var _this = this;
      switch (locale) {
        case "cn":
          locale = "zh-CN";
          break;
        case "en":
          locale = "en-US";
          break;
      }
      return locale;
    },
    id() {
      return "address_field_" + this._uid;
    },
    result() {
      let result = [];
      result.push(this.postcode);
      result.push(this.country.display_text);
      result.push(this.region);
      result.push(this.city);
      result.push(this.town);
      result.push(this.street);
      result.push(this.number);
      result.push(this.office);
      if (this.code_of_type !== "") {
        result.push(
          this.$t(
            "message.contracts.address_typed_field_" + this.code_of_type,
          ) +
            ": " +
            this.additional_data,
        );
      }
      let ctr = 0;
      result.forEach((i) => {
        if (i && i.trim() !== "") ctr++;
      });
      if (ctr > 0) return result.join(", ");
      else return "";
    },
  },
};
</script>
